import React from 'react';
import { useTranslation } from 'react-i18next';

import { Loading3QuartersOutlined } from '@ant-design/icons';

import UserIconGroup from 'components/shared/UserIconGroup';
import { COLORS } from 'constants/colors';
import { ROLES } from 'constants/global';
import { IDBUser, PollOption } from 'constants/types';

import TextOption from './TextOption';
import CheckCircleFilledIcon from './icons/CheckCircleFilled.svg';
import {
  Container,
  InfoWrapper,
  OptionValue,
  OptionVotes,
  ValuesWrapper,
} from './styles';

interface PollOptionsProps {
  text: string;
  index: number;
  percentage: number;
  option: PollOption;
  onSelectOption: () => void;
  isSelected: boolean;
  disabled: boolean;
  loading: boolean;
  userVoted: boolean;
  isRegularUser: boolean;
  recentVoters: IDBUser[];
}

const PollOptions: React.FC<PollOptionsProps> = ({
  text,
  index,
  percentage,
  option,
  onSelectOption,
  isSelected,
  disabled,
  loading,
  userVoted,
  isRegularUser,
  recentVoters,
}) => {
  const { t } = useTranslation('forum');
  return (
    <Container
      percentage={userVoted || !isRegularUser ? percentage : 100}
      onClick={!disabled ? onSelectOption : undefined}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <InfoWrapper>
        {loading ? (
          <Loading3QuartersOutlined
            style={{ color: COLORS.geekBlue5, fontSize: '16px' }}
            spin={true}
          />
        ) : (
          isSelected && <img src={CheckCircleFilledIcon} alt="Selected" />
        )}

        <TextOption>
          {index + 1}. {text}
        </TextOption>
      </InfoWrapper>
      {option.voteCount && (userVoted || !isRegularUser) && (
        <ValuesWrapper>
          <UserIconGroup users={recentVoters} iconSize="24" overlap="10px" />
          <OptionVotes>
            {option.voteCount === 1
              ? t('vote_count', { count: option.voteCount })
              : t('votes_count', { count: option.voteCount })}
          </OptionVotes>
          <OptionValue>{`${percentage}%`}</OptionValue>
        </ValuesWrapper>
      )}
    </Container>
  );
};

export default PollOptions;
